import { render, staticRenderFns } from "./AssociateRequirement.vue?vue&type=template&id=c486538e"
import script from "./AssociateRequirement.vue?vue&type=script&lang=js"
export * from "./AssociateRequirement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports